import {
  get,
  merge,
  mergeWith,
  isArray,
  uniq,
  filter,
  remove,
  findIndex,
  omit,
} from 'lodash';

import {
  STATUSES,
  TITLES,
  PRIORITIES_BY_STATUS,
} from '../../components/CRM/Tickets/TicketStatus/constants';

import {
  ADD_TICKET_IN_TICKET_LIST,
  CREATE_TICKET,
  CREATE_TICKET_FINISH,
  CREATE_TICKET_SUCCESS,
  CLOSE_TICKET_SUCCESS,
  DELETE_TICKET_FROM_TICKET_LIST,
  FETCH_TICKETS,
  RESET_TICKET_ERRORS,
  SET_CLIENTS_OPTIONS,
  SET_CLOSE_REASONS_OPTIONS,
  SET_COUNTRIES_OPTIONS,
  SET_DEPARTURE_OPTIONS,
  SET_REASON_OPTIONS,
  SET_MAIL_GROUP_OPTIONS,
  SET_SKILL_GROUP_OPTIONS,
  SET_MANAGER_OPTIONS,
  SET_ORDER_SEGMENT_OPTIONS,
  SET_PAGE,
  SET_PARTNER_OPTIONS,
  SET_SOURCE_OPTIONS,
  SET_MENU_SOURCE_OPTIONS,
  SET_STATUSES_OPTIONS,
  SET_PLAN_REASONS_OPTIONS,
  SET_TAG_OPTIONS,
  SET_LABEL_OPTIONS,
  SET_TEMPLATE_OPTIONS,
  SET_TICKET_CLIENT,
  SET_TICKET_FILTERS,
  SET_TICKET_RELATIVES,
  SET_TICKET_SUGGESTED_ORDERS,
  SET_TICKET_UPDATED_CLIENT,
  SET_TICKET,
  SET_TICKETS,
  SET_IS_LOADING_ACTIVE_TICKET,
  SET_EXCESS_TICKETS,
  SET_TOUR_SELECTION,
  TRIGGER_NEW_TICKET,
  WS_UPDATE_ACTIVE_TICKET,
  UPDATE_TICKET_IN_TICKET_LIST,
  UPDATE_TICKET_OWN_ORDERS,
  UPDATE_TICKET_RELATIVES,
  UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT,
  SET_TICKETS_TAB,
  SET_TICKETS_SORT,
  SELECT_TICKET,
  SELECT_CLIENT,
  RESERVE_TICKET,
  SUCCESS_TICKET_RESERVATION,
  FAIL_TICKET_RESERVATION,
  CLEAR_TICKET_FILTERS,
  SET_CURRENT_MANAGER_TO_INITIAL_FILTERS,
  SET_ACTIVE_TICKET_INFO,
  SET_CLIENT_ATTACHMENTS,
} from '../actions/tickets';

import { SET_CURRENT_MANAGER } from '../actions/general';

import getTicketPosition from '../../utils/getTicketPosition';
import { initialState } from './initialState';
import { FILTER_TABS } from '../../components/CRM/Tickets/TicketFilters/constants';
import { customMerge } from '../sagas/utils/utils';

export const initialMeta = {
  page: 1,
  size: 50,
  total: 0,
  unassigned: 0,
  totalPages: 1,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS: {
      return {
        ...state,
        isFirstTimeLoading: true,
        isNextPageLoading: true,
      };
    }

    case SELECT_CLIENT: {
      return {
        ...state,
        activeTicket: null,
        activeTicketId: null,
        excessTickets: [],
      };
    }

    case SELECT_TICKET: {
      const { id: activeTicketId } = action.payload;

      return {
        ...state,
        activeTicket: null,
        activeTicketId,
        excessTickets: [],
        prevActiveTicketId: state.activeTicketId,
        prevActiveTicketClientId: state.activeTicket?.client?.id || null,
      };
    }

    case SET_TICKET: {
      const { ticket: activeTicket } = action.payload;
      const activeTicketId = get(activeTicket, 'ticket.id');

      return {
        ...state,
        activeTicket,
        activeTicketId,
        options: {
          ...state.options,
          destinations: [],
        },
      };
    }

    case SET_IS_LOADING_ACTIVE_TICKET: {
      return {
        ...state,
        isLoadingActiveTicket: action.payload,
      };
    }

    case SET_EXCESS_TICKETS: {
      return {
        ...state,
        excessTickets: action.payload.excessTickets,
      };
    }

    case CREATE_TICKET_SUCCESS: {
      const { ticket: activeTicket } = action.payload;
      const activeTicketId = get(activeTicket, 'ticket.id');

      return {
        ...state,
        activeTicket: {
          ...state.activeTicket,
          ...activeTicket,
        },
        activeTicketId,
      };
    }

    case CREATE_TICKET: {
      return {
        ...state,
        isCreateTicketLoading: true,
      };
    }

    case CREATE_TICKET_FINISH: {
      return {
        ...state,
        isCreateTicketLoading: false,
      };
    }

    case CLOSE_TICKET_SUCCESS: {
      const { activeTicket } = state;

      if (!activeTicket?.ticket) return state;

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          ticket: {
            ...activeTicket.ticket,
            hasPriorityService: false,
            isClosed: true,
          },
        },
      };
    }

    case SET_TICKETS_TAB: {
      const { tab } = action.payload;

      return {
        ...state,
        activeTicketsTab: tab,
        tickets: [],
        ticketIds: {},
        ticketListMeta: initialMeta,
        isFirstTimeLoading: true,
        isNextPageLoading: false,
      };
    }

    case SET_TICKETS_SORT: {
      const { sort } = action.payload;

      return {
        ...state,
        ticketsSort: sort,
        tickets: [],
        ticketIds: {},
        ticketListMeta: initialMeta,
        isFirstTimeLoading: true,
        isNextPageLoading: false,
      };
    }

    case SET_TICKETS: {
      const { tickets, ticketIds, meta } = action.payload;
      const { total, unassigned, total_pages: totalPages } = meta;

      return {
        ...state,
        ticketListMeta: {
          ...state.ticketListMeta,
          total,
          unassigned,
          totalPages,
        },
        isFirstTimeLoading: false,
        isNextPageLoading: false,
        tickets,
        ticketIds,
      };
    }

    case SET_PAGE: {
      const { page } = action.payload;
      return {
        ...state,
        ticketListMeta: {
          ...state.ticketListMeta,
          page,
        },
        isNextPageLoading: true,
      };
    }

    case SET_TOUR_SELECTION: {
      const { activeTicket } = state;
      const { tourSelection } = action.payload;

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          tourSelection,
        },
      };
    }

    case SET_TICKET_SUGGESTED_ORDERS: {
      const { activeTicket } = state;
      const { orders } = action.payload;

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          suggestedOrders: orders,
        },
      };
    }

    case UPDATE_TICKET_RELATIVES: {
      const { activeTicket, activeTicketId } = state;

      if (!activeTicketId) {
        return state;
      }

      const { relatives: oldRelativeTickets } = activeTicket;
      const { ticket: updatedTicket } = action.payload;

      const updatedRelatives = oldRelativeTickets.map(ticketItem => {
        const { ticket: oldTicket } = ticketItem;
        if (oldTicket.id === updatedTicket.id) {
          return {
            ...ticketItem,
            ticket: {
              ...oldTicket,
              ...updatedTicket,
            },
          };
        }
        return ticketItem;
      });

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          relatives: updatedRelatives,
        },
      };
    }

    case SET_TICKET_CLIENT: {
      const { client, orders } = action.payload;
      return {
        ...state,
        activeTicket: {
          ...state.activeTicket,
          client,
          orders,
          isClientLoaded: true,
        },
      };
    }

    case SET_CLIENT_ATTACHMENTS: {
      const { activeTicket } = state;
      const { clientID, attachmentsByOrderId } = action.payload;

      if (activeTicket?.client?.id !== clientID) return;

      return {
        ...state,
        activeTicket: {
          ...state.activeTicket,
          attachmentsByOrderId,
        },
      };
    }

    case SET_TICKET_UPDATED_CLIENT: {
      const { client: updatedClient } = action.payload;
      const { tickets: allTickets, activeTicket: prevActiveTicket } = state;

      const tickets = allTickets.map(ticketItem => {
        const { id, phone } = ticketItem?.client;
        if (updatedClient.id === id || updatedClient.phone === phone) {
          return {
            ...ticketItem,
            client: updatedClient,
            isClientLoaded: true,
          };
        }

        return ticketItem;
      });

      return {
        ...state,
        errors: {},
        tickets,
        activeTicket: {
          ...prevActiveTicket,
          client: updatedClient,
        },
      };
    }

    case SET_TICKET_RELATIVES: {
      const { tickets: relatives } = action.payload;
      return {
        ...state,
        activeTicket: {
          ...state.activeTicket,
          relatives,
        },
      };
    }

    case RESET_TICKET_ERRORS: {
      return { ...state, errors: {} };
    }

    case SET_TAG_OPTIONS: {
      const { tags } = action.payload;

      if (!tags && tags.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          tags: tags.map(tag => ({
            id: tag.id,
            label: tag.title,
            value: tag.title,
            backgroundColor: tag.backgroundColor,
            textColor: tag.textColor,
            active: tag.active,
            isRemovable: tag.isRemovable,
          })),
        },
      };
    }

    case SET_LABEL_OPTIONS: {
      const { labels } = action.payload;

      if (!labels && labels.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          labels: labels.map(label => ({
            label: label.title,
            value: label.id,
            backgroundColor: label.backgroundColor,
            textColor: label.textColor,
          })),
        },
      };
    }

    case SET_TEMPLATE_OPTIONS: {
      const { templates } = action.payload;

      if (!templates && templates.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          templates,
        },
      };
    }

    case SET_MANAGER_OPTIONS: {
      const { managers } = action.payload;
      return {
        ...state,
        options: {
          ...state.options,
          managers,
        },
      };
    }

    case SET_MAIL_GROUP_OPTIONS: {
      const { mailGroups } = action.payload;
      if (!mailGroups || mailGroups.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          mailGroups: mailGroups.map(mailGroup => ({
            label: mailGroup.title,
            value: mailGroup.id,
            skillGroupId: mailGroup.skillGroupId,
          })),
        },
      };
    }

    case SET_SKILL_GROUP_OPTIONS: {
      const { skillGroups } = action.payload;
      if (!skillGroups || skillGroups.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          skillGroups: skillGroups.map(skillGroup => ({
            label: skillGroup.title,
            value: skillGroup.id,
          })),
        },
      };
    }

    case SET_PARTNER_OPTIONS: {
      const { partners } = action.payload;
      if (!partners || partners.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          partners: partners.map(partner => ({
            label: partner.name,
            value: partner.id,
          })),
        },
      };
    }

    case SET_REASON_OPTIONS: {
      const { reasons } = action.payload;
      if (!reasons || reasons.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          reasons: reasons.map(reason => ({
            label: reason.title,
            value: reason.id,
            active: reason.active,
          })),
        },
      };
    }

    case SET_CLOSE_REASONS_OPTIONS: {
      const { closeReasons } = action.payload;

      if (!closeReasons || closeReasons.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          closeReasons: filter(closeReasons, ['isSuccess', false]).map(
            reason => ({
              ...reason,
              label: reason.title,
              value: reason.id,
            })
          ),
        },
      };
    }

    case SET_SOURCE_OPTIONS: {
      const { sources } = action.payload;
      if (!sources || sources.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          sources: sources.map(source => ({
            label: source.title,
            value: source.id,
          })),
        },
      };
    }

    case SET_MENU_SOURCE_OPTIONS: {
      const { sources } = action.payload;
      if (!sources || sources.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          menuSources: sources.map(source => ({
            label: source.title,
            value: source.id,
          })),
        },
      };
    }

    case SET_STATUSES_OPTIONS: {
      const statuses = Object.values(STATUSES).map(value => ({
        value,
        title: TITLES[value],
        priority: PRIORITIES_BY_STATUS[value],
      }));

      return {
        ...state,
        options: {
          ...state.options,
          statuses,
        },
      };
    }

    case SET_CLIENTS_OPTIONS: {
      const clients = action.payload;

      return {
        ...state,
        options: {
          ...state.options,
          clients,
        },
      };
    }

    case SET_ORDER_SEGMENT_OPTIONS: {
      const { orderSegments } = action.payload;
      if (!orderSegments || orderSegments.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          segments: orderSegments.map(segment => ({
            label: segment.shortTitle,
            value: segment.id,
          })),
        },
      };
    }

    case SET_DEPARTURE_OPTIONS: {
      const { departures } = action.payload;
      if (!departures || departures.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          departures: departures.map(departure => ({
            label: departure.name,
            value: departure.id,
          })),
        },
      };
    }

    case SET_COUNTRIES_OPTIONS: {
      const { countries } = action.payload;
      if (!countries || countries.length <= 0) return state;

      return {
        ...state,
        options: {
          ...state.options,
          countries: countries.map(destination => ({
            id: destination.id,
            label: destination.name,
            value: destination.value,
          })),
        },
      };
    }

    case SET_PLAN_REASONS_OPTIONS: {
      const { planReasons } = action.payload;

      return {
        ...state,
        options: {
          ...state.options,
          planReasons: filter(planReasons || [], ['isActive', true]).map(
            reason => ({
              ...reason,
              label: reason.title,
              value: reason.id,
            })
          ),
        },
      };
    }

    case SET_CURRENT_MANAGER: {
      const { initialFilters, filters: stateFilters, ticketsSort } = state;
      const { currentManager } = action.payload;

      const { id, isSupervisor } = currentManager;

      const hasSkillGroups = currentManager.skillGroupIds?.length;

      if (isSupervisor || !hasSkillGroups) return state;

      const updatedInitialFilters = {
        ...initialFilters,
        [FILTER_TABS.ACTUAL]: {
          ...initialFilters[FILTER_TABS.ACTUAL],
          managers: [id],
        },
      };

      return {
        ...state,
        filters: updatedInitialFilters,
        prevFilters: stateFilters,
        prevTicketsSort: ticketsSort,
        initialFilters: updatedInitialFilters,
      };
    }

    case SET_CURRENT_MANAGER_TO_INITIAL_FILTERS: {
      const { initialFilters, filters: stateFilters, ticketsSort } = state;
      const { managers } = action.payload;

      const updatedInitialFilters = {
        ...initialFilters,
        [FILTER_TABS.ACTUAL]: {
          ...initialFilters[FILTER_TABS.ACTUAL],
          managers,
        },
      };

      return {
        ...state,
        filters: updatedInitialFilters,
        prevFilters: stateFilters,
        prevTicketsSort: ticketsSort,
        initialFilters: updatedInitialFilters,
      };
    }

    case SET_TICKET_FILTERS: {
      const { filters: stateFilters, ticketsSort, activeTicketsTab } = state;
      const { filters } = action.payload;

      const newFilters = { ...filters };
      Object.keys(newFilters).forEach(
        key => newFilters[key] == null && delete newFilters[key]
      );

      return {
        ...state,
        filters: {
          ...stateFilters,
          [activeTicketsTab]: newFilters,
        },
        prevFilters: stateFilters,
        prevTicketsSort: ticketsSort,
        tickets: [],
        ticketIds: {},
        ticketListMeta: initialMeta,
        isFirstTimeLoading: true,
        isNextPageLoading: false,
      };
    }

    case CLEAR_TICKET_FILTERS: {
      const { initialFilters, filters: stateFilters, ticketsSort } = state;

      return {
        ...state,
        filters: initialFilters,
        prevFilters: stateFilters,
        prevTicketsSort: ticketsSort,
        tickets: [],
        ticketIds: {},
        ticketListMeta: initialMeta,
        isFirstTimeLoading: true,
        isNextPageLoading: false,
      };
    }

    case TRIGGER_NEW_TICKET: {
      return {
        ...state,
        activeTicketId: null,
        activeTicket: {
          ...state.activeTicket,
          id: null,
          ticket: null,
          ownOrders: [],
          tourSelection: null,
        },
      };
    }

    case WS_UPDATE_ACTIVE_TICKET: {
      const { ticket } = action.payload;
      if (!ticket) return state;

      const managersList = state.options.managers;

      const {
        ticket: updatedTicketField,
        client,
        ownOrders: updatedOrders = [],
      } = ticket;

      const { activeTicket } = state;

      const ticketFields =
        activeTicket.ticket.isClosed &&
        updatedTicketField.status?.title === undefined
          ? omit(updatedTicketField, ['hasPriorityService', 'isClosed'])
          : updatedTicketField;

      let manager;

      if (updatedTicketField.manager === null) {
        manager = null;
      } else if (updatedTicketField.manager === undefined) {
        manager = activeTicket.manager;
      } else {
        manager = managersList.find(m => m.id === updatedTicketField.manager);
      }
      const { tags } = updatedTicketField;

      const orderIds = updatedTicketField.orderIds;
      const orderIdsSet = orderIds
        ? new Set(orderIds.map(id => String(id)))
        : null;

      const newOrdersData = {};
      if (Array.isArray(updatedOrders)) {
        const updatedOrderEntries = updatedOrders.map(order => [
          order.id,
          order,
        ]);
        const mergeOrdersList = (ordersList = [], { filterSet } = {}) => {
          const updatesMap = new Map(updatedOrderEntries);
          const merged = ordersList.map(order => {
            const updatedOrder = updatesMap.get(order.id);

            if (!updatedOrder) {
              return order;
            }

            updatesMap.delete(order.id);
            return { ...order, ...updatedOrder };
          });

          const result = merged.concat(Array.from(updatesMap.values()));

          if (filterSet) {
            return result.filter(order => filterSet.has(String(order.id)));
          }

          return result;
        };

        newOrdersData.orders = mergeOrdersList(activeTicket.orders || []);
        newOrdersData.ownOrders = mergeOrdersList(
          activeTicket.ownOrders || [],
          { filterSet: orderIdsSet }
        );
      }

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          ticket: {
            ...merge({}, activeTicket.ticket, ticketFields),
            ...(tags ? { tags: uniq(tags) } : {}),
            ...(orderIds ? { orderIds: uniq(orderIds) } : {}),
          },

          manager,
          client: merge({}, activeTicket.client, client),
          ...newOrdersData,
        },
      };
    }

    case UPDATE_TICKET_OWN_ORDERS: {
      const { ownOrders } = action.payload;
      return {
        ...state,
        activeTicket: {
          ...state.activeTicket,
          ownOrders,
        },
      };
    }

    case ADD_TICKET_IN_TICKET_LIST: {
      const { ticket } = action.payload;
      const { ticketListMeta, tickets, ticketIds, filters } = state;
      const { total, page, totalPages } = ticketListMeta;

      ticketIds[ticket.id] = true;

      // delete when back fix duplicate ticket
      if (
        findIndex(tickets, ticketInList => ticketInList.id === ticket.id) >= 0
      ) {
        const updatedTickets = tickets.map(ticketItem => {
          const { ticket: oldTicket } = ticketItem;
          if (oldTicket.id === ticket.id) {
            return ticket;
          }
          return ticketItem;
        });

        return {
          ...state,
          tickets: updatedTickets,
          ticketIds,
        };
      }

      const order = filters.desc ? 'DESC' : 'ASC';
      const updatedTickets = [...tickets];
      const newTicketPosition = getTicketPosition({
        tickets: updatedTickets,
        newTicket: ticket,
        order,
        lastPage: page >= totalPages,
      });

      if (newTicketPosition !== -1) {
        updatedTickets.splice(newTicketPosition, 0, ticket);
      }

      return {
        ...state,
        tickets: updatedTickets,
        ticketIds,
        ticketListMeta: {
          ...ticketListMeta,
          total: total + 1,
        },
      };
    }

    case DELETE_TICKET_FROM_TICKET_LIST: {
      const { ticketId } = action.payload;
      const { ticketListMeta, tickets, ticketIds } = state;
      const { total } = ticketListMeta;

      const removableTicket = tickets.find(ticket => ticket.id === ticketId);
      if (!removableTicket) return state;

      const ticketWithoutDeletedTicket = filter(
        tickets,
        ticket => ticket.id !== ticketId
      );

      delete ticketIds[ticketId];

      return {
        ...state,
        tickets: ticketWithoutDeletedTicket,
        ticketIds,
        ticketListMeta: {
          ...ticketListMeta,
          total: total - 1,
        },
      };
    }

    case UPDATE_TICKET_IN_TICKET_LIST: {
      const { tickets, ticketIds, filters, ticketListMeta } = state;
      const { ticket } = action.payload;

      if (!ticket || !(ticket.id in ticketIds)) return state;

      const { ticket: updatedTicketField, manager } = ticket;
      const { page, totalPages } = ticketListMeta;
      const updatedTickets = [...tickets];
      let newTicket = null;

      remove(updatedTickets, ticketItem => {
        const { ticket: oldTicket } = ticketItem;
        if (oldTicket.id === ticket.id) {
          const ticketFields =
            oldTicket.isClosed && updatedTicketField.status?.title === undefined
              ? omit(updatedTicketField, ['hasPriorityService', 'isClosed'])
              : updatedTicketField;

          newTicket = {
            ...ticketItem,
            ticket: mergeWith(
              {},
              ticketItem.ticket,
              ticketFields,
              customMerge
            ),
            manager: merge({}, ticketItem.manager, manager),
          };

          return true;
        }
        return false;
      });

      if (!newTicket) return state;

      const order = filters.desc ? 'DESC' : 'ASC';
      const newTicketPosition = getTicketPosition({
        tickets: updatedTickets,
        newTicket,
        order,
        lastPage: page === totalPages,
      });

      if (newTicketPosition !== -1) {
        updatedTickets.splice(newTicketPosition, 0, newTicket);
      }

      return {
        ...state,
        tickets: updatedTickets,
      };
    }

    case RESERVE_TICKET: {
      return {
        ...state,
        isTicketReservationLoading: true,
      };
    }

    case SUCCESS_TICKET_RESERVATION: {
      const { activeTicket } = state;
      const isAssigned = action.payload;

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          ticket: {
            ...activeTicket.ticket,
            isAssigned,
          },
        },
        isTicketReservationLoading: false,
      };
    }

    case FAIL_TICKET_RESERVATION: {
      return {
        ...state,
        isTicketReservationLoading: false,
      };
    }

    case SET_ACTIVE_TICKET_INFO: {
      const { activeTicket } = state;
      const { info } = action.payload;

      return {
        ...state,
        activeTicket: {
          ...activeTicket,
          info,
        },
      };
    }

    case UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT: {
      const { ticketListMeta } = state;
      const { unassignedCount: unassigned, unassignedCountsByMailGroups } =
        action.payload;

      return {
        ...state,
        unassignedCountsByMailGroups,
        ...(ticketListMeta.unassigned !== unassigned && {
          ticketListMeta: {
            ...state.ticketListMeta,
            unassigned,
          },
        }),
      };
    }

    default:
      return state;
  }
};
